class TransactionDocumentUploadData {
  referenceNumber: string;
  fileSn: number;
  constructor(referenceNumber: string, fileSn: number) {
    this.referenceNumber = referenceNumber;
    this.fileSn = fileSn;
  }
}

export { TransactionDocumentUploadData };
